<template>
  <div class="title-bar clearfix">
    <div slot="header" class="clearfix">
      <div class="module pull-left">
        {{ $t("CashbackManagement") }}
      </div>

      <div class="btn-group pull-right">
        <el-tooltip v-if="canEdit" content="所有搜索结果禁用红包领取" placement="top">
          <el-button :plain="true" size="mini" @click="inavtivationAll">禁用红包
            <i class="fa fa-lock"></i>
          </el-button>
        </el-tooltip>
        <el-tooltip v-if="canEdit" content="所有搜索结果启用红包领取" placement="top">
          <el-button :plain="true" size="mini" @click="avtivationAll">启用红包
            <i class="fa fa-unlock"></i>
          </el-button>
        </el-tooltip>
        <el-button :plain="true" size="mini" @click="refresh">{{ $t("refresh") }}
          <i class="fa fa-refresh"></i>
        </el-button>
        <el-button :plain="true" size="mini" @click="userTypeSetup">{{ $t("search") }}
          <i class="fa fa-search"></i>
        </el-button>

      </div>
    </div>
    <div class="data-list" v-loading="loading" element-loading-text="Loading">

      <el-table class="customer-table" border stripe :data="CashbackData" size="mini" @cell-dblclick="openCell">
        <el-table-column label="操作" align="center" width="180" :resizable="true" v-if="canEdit">
          <template slot-scope="scope">
            <el-button size="mini" type="text" @click="handleEdit(scope.$index, scope.row)">{{$t("edit")}}</el-button>
            <el-button size="mini" type="text" @click="handleActivation(scope.$index, scope.row)">{{scope.row.IsActive ? $t("inActivation") : $t("activation")}}</el-button>
            <el-button size="mini" v-if="false" type="text" @click="handleDelete(scope.$index, scope.row)">{{$t("delete")}}</el-button>
          </template>
        </el-table-column>
        <el-table-column label="红包领取" align="center" width="100" :resizable="true">
          <template slot-scope="scope">
            <i v-if="scope.row.IsActive" class="el-icon-success"></i>
            <i v-else class="el-icon-error"></i>
          </template>
        </el-table-column>
        <el-table-column prop="EANCode" header-align="center" :label="this.$t('EANCode')" align="center">
        </el-table-column>
        <el-table-column prop="ProductLongCode" :label="this.$t('ProductLongCode')" header-align="center" align="center">
        </el-table-column>
        <el-table-column prop="userType" :label="this.$t('UserType')" :formatter="UserTypeFormatter" header-align="center" align="center">

        </el-table-column>
        <el-table-column prop="CashbackAmount" :label="this.$t('CashbackAmount')" header-align="center" align="center">
          <template slot-scope="scope">
            <span v-if="!canEdit">{{ scope.row.CashbackAmount }}</span>
            <div v-if="canEdit">
              <span v-if="!scope.row.editFlag&&canEdit">{{ scope.row.CashbackAmount }}</span>
              <div style="width:90%;float:left;">
                <span v-if="scope.row.editFlag">
                  <div @keyup="handlekeyup($event)">
                    <el-input id="editinput" v-model="inputColumn1" placeholder="请输入返现金额" @keyup.esc.native=" handlecancel(scope.row)" @keyup.enter.native="handleSave(scope.row)">
                    </el-input>
                  </div>
                </span>
              </div>
              <span v-if="!scope.row.editFlag" style="margin-left:5px;" class="cell-icon" @click="handlePageEdit(scope.row)">
                <a title="编辑">
                  <i class="el-icon-edit"></i>
                </a>
              </span>

              <div style="float:left;margin-left:2px;">
                <span v-if="scope.row.editFlag" class="cell-icon" @click="handleSave(scope.row)">
                  <a title="保存">
                    <i class="fa fa-file" aria-hidden="true"></i>
                  </a>
                </span>
                <span v-if="scope.row.editFlag" class="cell-icon" @click="handlecancel(scope.row)">
                  <a title="取消">
                    <i class="el-icon-document"></i>
                  </a>
                </span>
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-row style="margin-top:10px;">
        <el-pagination style="float:right" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageIndex" :page-sizes="[15,30,50]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="totalCount">
        </el-pagination>
      </el-row>

      <el-dialog class="search-dialog" :title="this.$t('search')" :visible.sync="searchDialogVisible" width="45%">

        <el-form class="search-form" :model="filter" :inline="true" size="small" label-width="100px">

          <el-form-item :label="this.$t('EANCode')" size="small">
            <el-input v-model="filter.EANCode" auto-complete="off" class="localinputwidth"></el-input>
          </el-form-item>

          <el-form-item :label="this.$t('ProductLongCode')" size="small">
            <el-input v-model="filter.ProductLongCode" auto-complete="off" class="localinputwidth"></el-input>
          </el-form-item>

          <el-form-item :label="this.$t('CashbackAmount')" size="small">
            <div @keyup="handlekeyup($event)">
              <el-input v-model="filter.CashbackAmount" auto-complete="off" class="localinputwidth"></el-input>
            </div>
          </el-form-item>
          <el-form-item :label="this.$t('UserType')" size="small" class="usertype-selector">
            <el-select v-model="filter.userType" multiple size="small">
              <el-option v-for="t in userTypeList" :key="t" :label="$t('UserType'+t)" :value="t"></el-option>
            </el-select>
          </el-form-item>

        </el-form>

        <div slot="footer" class="search-footer" style="text-align:center">
          <el-button @click="searchDialogVisible = false" plain size="mini">{{this.$t('cancel')}}</el-button>
          <el-button @click="resetFilter" :plain="true" size="mini">{{$t('reset')}}</el-button>
          <el-button type="primary" @click="search" plain size="mini">{{this.$t('confirm')}}</el-button>
        </div>
      </el-dialog>

    </div>

  </div>

</template>
 
 
<script>
import OperationHeader from "@/components/shared/OperationHeader";
import qs from "qs";
import _ from "lodash";
import { mapGetters } from "vuex";
import roleTypes from "../../../models/roleTypes";
import searchTypes from "../../../models/searchTypes";
import CashbackAmountValidation from "./CashbackAmountValidation";
import searchHistoryService from "../../../services/searchHistoryService";
export default {
  name: "Cashback",
  components: { OperationHeader },
  data() {
    return {
      switchValue: "",
      loading: true,
      filter: {
        EANCode: "",
        ProductLongCode: "",
        userType: [],
        CashbackInformation: "",
        CashbackAmount: ""
      },
      CashbackInfo: {
        Id: "",
        EANCode: "",
        CashbackAmount: "",
        ProductLongCode: "",
        CashbackInformation: "",
        UserType: ""
      },
      userTypeList: [],
      searchDialogLabelWidth: "30%",
      pageIndex: 1,
      pageSize: 15,
      totalCount: 0,
      maxCashbackAmount: CashbackAmountValidation.maxCasbackAmount,
      minCashbackAmount: CashbackAmountValidation.minCasbackAmount,
      searchDialogVisible: false,
      CashbackData: [],
      filterOptions: [],
      inputColumn1: "",
      isEditing: false
    };
  },

  created() {
    this.initializeFilter();
    this.obtainTableDataAccordingToConditions();
    this.checkinput();
  },
  computed: {
    ...mapGetters(["roles", "permissions"]),
    canEdit() {
      return (
        this.roles.includes(roleTypes.Administrator) ||
        this.permissions.find(
          p =>
            p.toLowerCase() === "cashback.edit" ||
            p.toLowerCase() === "cashback.insert"
        )
      );
    }
  },
  methods: {
    handlePageEdit: function(row) {
      if (!this.isEditing) {
        this.inputColumn1 = row.CashbackAmount.split("￥")[0];
        row.editFlag = true;
        this.isEditing = true;
      }
    },
    handlecancel(row) {
      row.editFlag = false;
      this.isEditing = false;
      this.refresh();
    },
    checkinput() {
      setInterval(
        "if(document.getElementById('editinput'))document.getElementById('editinput').focus();",
        500
      );
    },
    openCell(row, column, cell, event) {
      if (!this.isEditing) {
        this.inputColumn1 = row.CashbackAmount.split("￥")[0];
        row.editFlag = true;
        this.isEditing = true;
      }
    },
    UserTypeFormatter: function(row, column) {
      var type = row.userType;
      return this.$t("UserType" + type);
    },
    handleSave: function(row) {
      this.isEditing = false;
      this.CashbackInfo = row;
      this.CashbackInfo.CashbackAmount = this.inputColumn1;

      if (
        this.CashbackInfo.CashbackAmount == null ||
        this.CashbackInfo.CashbackAmount == ""
      ) {
        this.obtainTableDataAccordingToConditions();
        return;
      }
      if (this.CashbackInfo.CashbackAmount > this.maxCashbackAmount) {
        this.CashbackInfo.CashbackAmount = this.maxCashbackAmount;
      }
      if (
        this.CashbackInfo.CashbackAmount > 0 &&
        this.CashbackInfo.CashbackAmount < this.minCashbackAmount
      ) {
        this.CashbackInfo.CashbackAmount = this.minCashbackAmount;
      }

      this.CashbackInfo.CashbackAmount = parseFloat(
        this.CashbackInfo.CashbackAmount
      ).toFixed(2);
      this.$axios
        .post("api/cashback/edit", this.CashbackInfo)
        .then(response => {
          this.$message({
            message: this.$t("CashbackEditSuccessfully"),
            type: "success",
            showClose: true,
            duration: 2000
          });
          this.obtainTableDataAccordingToConditions();
        });
      row.editFlag = false;
      this.inputColumn1 = "";
    },
    handleMouseEnter: function(row, column, cell, event) {
      cell.children[0].children[1].style.color = "black";
    },
    handleMouseOut: function(row, column, cell, event) {
      cell.children[0].children[1].style.color = "#ffffff";
    },

    handleEdit(index, row) {
      this.$router.push({ name: "EditCashback", params: { Id: row.Id } });
    },

    handleActivation(index, row) {
      let tip = row.IsActive ? "禁用红包领取" : "启用红包领取";
      this.$confirm(`确定${tip}吗？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.$axios({
          method: "post",
          url: "api/cashback/changeActivationStatus",
          data: { id: row.Id }
        }).then(response => {
          this.$message({
            message: `${tip}成功`,
            type: "success",
            showClose: true,
            duration: 2000
          });
          this.obtainTableDataAccordingToConditions();
        });
      });
    },
    inavtivationAll() {
      this.$confirm("确定禁用所有红包领取吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        let params = {
          filter: this.filtergenerator()
        };
        this.$axios
          .post("api/cashback/inavtivateAll", {}, { params })
          .then(response => {
            this.$message({
              message: "禁用所有红包领取成功",
              type: "success",
              showClose: true,
              duration: 2000
            });
            this.obtainTableDataAccordingToConditions();
          });
      });
    },
    avtivationAll() {
      this.$confirm("确定启用所有红包领取吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        let params = {
          filter: this.filtergenerator()
        };
        this.$axios
          .post("api/cashback/activateAll", {}, { params })
          .then(response => {
            this.$message({
              message: "启用所有红包领取成功",
              type: "success",
              showClose: true,
              duration: 2000
            });
            this.obtainTableDataAccordingToConditions();
          });
      });
    },

    handleDelete(index, row) {
      this.$confirm("确定要删除", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.deleteData(row.Id);
      });
    },

    resetFilter() {
      this.filter = {
        EANCode: "",
        ProductLongCode: "",
        userType: [],
        CashbackInformation: "",
        CashbackAmount: ""
      };

      this.filterOptions = [];
      searchHistoryService.removeHistory(searchTypes.CASHBACK_HISTORY);
    },

    handleSizeChange(val) {
      this.pageSize = val;
      if (this.pageIndex === 1) {
        this.obtainTableDataAccordingToConditions();
      } else {
        this.pageIndex = 1;
      }
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.obtainTableDataAccordingToConditions();
    },
    handlekeyup(event) {
      var father = event.currentTarget;
      var obj = father.getElementsByTagName("input")[0];

      obj.value = obj.value.replace(/[^\d.]/g, "");
      obj.value = obj.value.replace(/\.{2,}/g, ".");
      obj.value = obj.value
        .replace(".", "$#$")
        .replace(/\./g, "")
        .replace("$#$", ".");
      obj.value = obj.value.replace(/^(\-)*(\d+)\.(\d\d).*$/, "$1$2.$3");
      if (obj.value.indexOf(".") < 0 && obj.value != "") {
        obj.value = parseFloat(obj.value);
      }
      if (obj.value > this.maxCashbackAmount) {
        obj.value = this.maxCashbackAmount;
      }

      if (
        parseFloat(obj.value) > 0 &&
        parseFloat(obj.value) < this.minCashbackAmount
      ) {
        obj.value = this.minCashbackAmount;
      }
    },

    obtainTableDataAccordingToConditions() {
      this.loading = true;
      this.$axios
        .get("api/cashback/getcashback", {
          params: {
            filter: this.filtergenerator(),
            pageIndex: this.pageIndex,
            pageSize: this.pageSize
          }
        })
        .then(response => {
          this.translateData(response.data.Data);

          this.loading = false;
          this.totalCount = response.data.TotalCount;
        });
    },
    deleteData(rowId) {
      this.$axios
        .get("api/cashback/deletecashback", {
          params: {
            Id: rowId
          }
        })
        .then(response => {
          this.$message({
            type: "success",
            message: "删除成功"
          });
          this.refresh();
        });
    },
    refresh() {
      this.isEditing = false;
      this.pageIndex = 1;
      this.inputColumn1 = "";
      this.resetFilter();
      this.obtainTableDataAccordingToConditions();
    },

    userTypeSetup() {
      this.searchDialogVisible = true;

      if (this.userTypeList == "") {
        for (var i = 2; i <= 4; i++) {
          this.userTypeList.push(i);
        }
        this.userTypeList.push(8);
        this.userTypeList.push(9);
      }
    },

    translateData(data) {
      for (var i = 0; i < data.length; i++) {
        data[i].CashbackAmount = data[i].CashbackAmount + "￥";
        data[i].editFlag = false;
      }
      this.CashbackData = data;
    },

    initializeFilter() {
      let his = searchHistoryService.getHistory(searchTypes.CASHBACK_HISTORY);
      if (his) {
        let keys = Object.keys(this.filter);
        his.forEach(h => {
          if (keys.includes(h.name)) {
            this.filter[h.name] = h.value;
          }
        });
        this.setFilterOptions();
      }
    },
    setFilterOptions() {
      this.filterOptions = [];
      Object.keys(this.filter).forEach(k => {
        let val = this.filter[k];
        if (typeof val === "number" || val) {
          this.filterOptions.push({ name: k, value: val });
        }
      });
    },

    search() {
      this.searchDialogVisible = false;

      this.pageIndex = 1;
      this.setFilterOptions();
      searchHistoryService.setHistory(
        searchTypes.CASHBACK_HISTORY,
        this.filterOptions
      );
      this.obtainTableDataAccordingToConditions();
    },

    filtergenerator() {
      var filterOptions = [];
      if (this.filter.EANCode !== null && this.filter.EANCode.trim() !== "") {
        var filterOption = {
          name: "EANCode",
          value: this.filter.EANCode
        };

        filterOptions.push(filterOption);
      }

      if (
        this.filter.ProductLongCode !== null &&
        this.filter.ProductLongCode.trim() !== ""
      ) {
        var filterOption = {
          name: "ProductLongCode",
          value: this.filter.ProductLongCode
        };

        filterOptions.push(filterOption);
      }

      if (
        this.filter.CashbackAmount !== null &&
        this.filter.CashbackAmount.trim() !== ""
      ) {
        var filterOption = {
          name: "CashbackAmount",
          value: this.filter.CashbackAmount
        };
        filterOptions.push(filterOption);
      }
      if (
        this.filter.CashbackInformation !== null &&
        this.filter.CashbackInformation.trim() !== ""
      ) {
        var filterOption = {
          name: "CashbackInformation",
          value: this.filter.CashbackInformation
        };

        filterOptions.push(filterOption);
      }
      if (this.filter.userType.length > 0) {
        var selectedTypes = "";
        var count = 0;

        for (var i = 0; i < this.filter.userType.length; i++) {
          selectedTypes += this.filter.userType[i];
          if (count !== this.filter.userType.length - 1) {
            selectedTypes += "%";
          }
          count++;
        }

        var filterOption = {
          name: "UserType",
          value: selectedTypes
        };

        filterOptions.push(filterOption);
      }

      return JSON.stringify(filterOptions);
    }
  }
};
</script>
<style>
.el-icon-error {
  color: #ff0066;
}
.el-icon-success {
  color: #7ab51d;
}
</style>




// WEBPACK FOOTER //
// src/components/application/Cashback/Cashback.vue